(() => {
  const rules = `
    h2 { line-height:1.17 !important; letter-spacing:-.025em; margin-bottom:12px !important; }
    p, [class*="textBody"] { line-height:1.65 !important; }
    form + div { font-size:14px !important; line-height:1.6 !important; margin-top:16px !important; }
    input:not([type="checkbox"]) { font-size:16px !important; min-height:52px; }
    input[type="checkbox"] { width:20px; height:20px; flex:none; }
    label:has(input[type="checkbox"]) { min-height:44px; align-items:flex-start; }
    button[type="submit"] { min-height:56px; box-sizing:border-box !important; font-weight:600 !important; }
    button:focus-visible, input:focus-visible { outline:3px solid #b49acb !important; outline-offset:3px; }
    [data-current-step="success"] h2::before { content:"✧"; display:block; color:#69428f; font-size:36px; margin-bottom:20px; }
    @media (prefers-reduced-motion:reduce) { * { animation:none !important; transition:none !important; } }
  `;
  const decorate = () => {
    document.querySelectorAll('.card shopify-forms-embed').forEach(host => {
      const root = host.shadowRoot;
      if (!root || root.querySelector('[data-tnt-vip-polish]')) return;
      const style = document.createElement('style');
      style.dataset.tntVipPolish = '';
      style.textContent = rules;
      root.appendChild(style);
    });
  };
  const observer = new MutationObserver(decorate);
  observer.observe(document.body,{childList:true,subtree:true});
  const refresh = setInterval(decorate,250);
  setTimeout(() => clearInterval(refresh),15000);
  document.addEventListener('shopify:section:load',decorate);
  decorate();
})();
